import type { ReferenceRendererProps } from '@contember/react-client'
import type { ContentBlockReference } from '../../app/data/content/ContentFragment'

export const anchor = ({ reference }: ReferenceRendererProps<ContentBlockReference>) => {
	return <div id={reference.anchor}></div>
}
